import { styled } from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 4px;

  &:hover {
    background-color: ${myPalette.dark.buttonBackHover};
  }
`

export const Title = styled.span`
  font-size: 18px;
  font-weight: 500;
  color: ${myPalette.white.main};
`

export const IconWrapper = styled.div`
  padding: 10px;
  width: 40px;
  height: 40px;
  background: ${myPalette.midnightBlue['100']};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
